import MuiTooltip, { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const StyledTooltip = styled(MuiTooltip)(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.grey500,
    color: theme.palette.textPrimaryWhite,
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '16px',
    padding: '6px 10px',
    borderRadius: theme.radii.xs,
  },
  '& .MuiTooltip-arrow': {
    color: theme.palette.grey500,
  },
}));

const Tooltip = ({
  title,
  children,
  ...rest
}: MuiTooltipProps) => {
  return (
    <StyledTooltip title={title} arrow {...rest}>
      {children}
    </StyledTooltip>
  );
};

export default Tooltip;
